const reportstyle = {
    inputstyle: {
        color: "#636980",
        background: "none",
        border: "1px solid #E2E2E8",
        width: "100%",
        fontSize: "14px",
        fontWeight: "400",
        borderRadius: "24px",
        paddingLeft: "36px", // Add padding to prevent overlap with the image
        height: "32px", // Adjust as needed
        outline: "none",
      },
      imagestyle: {
        position: "absolute",
        left: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        height: "16px", // Adjust as needed
        width: "16px", // Adjust as needed
      },
      filterstyle: {
        position: "relative",
        width: "180px",
      },
      datestyle: {
        position: "relative",
        width: "180px",
      },
};

export default reportstyle;